import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { HomePage } from "./home";

class PbPreviewBase extends React.Component {
  render() {
    const bgColor = get(this.props, ["config", "pagebuilder-config", "home", "pageSetting", "bgColor"], "");
    return (
      <div style={{ backgroundColor: bgColor }}>
        {/* HomePage will be replaced by proper loader when section preview is implemented. */}
        <HomePage {...this.props} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    config: state.qt.config
  };
}

export const PbPreview = connect(mapStateToProps)(PbPreviewBase);
